
import PanelSmallScreen from './PanelSmallScreen.jsx';

export default PanelSmallScreen;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/PanelSmallScreen/index.js